<!-- appendTo: o painel dos ng-select abre na janela do modal (position: fixed) para nao ser cortado
     pelo scroll do simplebar; em ecras baixos abria para cima e as primeiras opcoes ficavam inacessiveis.
     appCloseSelectsOnScroll fecha o painel quando o separador faz scroll, porque ja nao acompanha o campo. -->
<ngx-simplebar appCloseSelectsOnScroll class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <form [formGroup]="propertyAreasNearbyForm" *ngIf="propertyAreasNearbyData" #formElementRef>
    <div class="row">
      <div class="card">
        <div class="card-header border-0 align-items-center d-flex pt-0 pb-2 border-bottom">
          <h4 class="card-title mb-0 flex-grow-1">Areas</h4>
          <div class="dropdown"><button
              class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
              type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"><i
                class=" ri-settings-2-line fs-14"></i></button>
            <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
              [ngStyle]="{'min-width':isBuildingImplantationArea?'18rem':'16rem'}">
              <div class="d-flex flex-column gap-2 filter-check">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-useful-area"
                    formControlName="hideUsefulArea">
                  <label class="form-check-label" for="hide-useful-area">
                    {{ 't-m-properties.t-hide-useful-area' | translate }}
                  </label>
                </div>

                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-gross-area"
                    formControlName="hideGrossArea">
                  <label class="form-check-label" for="hide-gross-area">
                    {{ 't-m-properties.t-hide-gross-area' | translate }}
                  </label>
                </div>

                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-gross-dependent-area"
                    formControlName="hideGrossDependentArea">
                  <label class="form-check-label" for="hide-gross-dependent-area">
                    {{ 't-m-properties.t-hide-gross-dependent-area' | translate }}
                  </label>
                </div>

                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-gross-private-area"
                    formControlName="hideGrossPrivateArea">
                  <label class="form-check-label" for="hide-gross-private-area">
                    {{ 't-m-properties.t-hide-gross-private-area' | translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-land-area"
                    formControlName="hideLandArea">
                  <label class="form-check-label" for="hide-land-area">
                    {{ 't-m-properties.t-hide-land-area' | translate }}
                  </label>
                </div>
                <div class="form-check form-switch" *ngIf="isBuildingImplantationArea">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-building-implantation-area"
                    formControlName="hideBuildingImplantationArea">
                  <label class="form-check-label" for="hide-building-implantation-area">
                    {{ 't-m-properties.t-hide-building-implantation-area' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="usefulareaInput" class="form-label">
                  {{ 't-m-properties.t-useful-area' | translate }} (m2)
                </label>

                <input type="number" class="form-control" id="usefulareaInput"
                  placeholder="{{ 't-enter' | translate }}  {{ 't-m-properties.t-useful-area' | translate }}"
                  formControlName="usefulArea"
                  [ngClass]="{ 'is-warning': submitted && form['usefulArea'].errors && form['usefulArea'].errors['warning'] }">
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-4">
              <div class="mb-3">
                <label for="grossareaInput" class="form-label">
                  {{ 't-m-properties.t-gross-area' | translate }} (m2)
                </label>

                <input type="number" class="form-control" id="grossareaInput"
                  placeholder="{{ 't-enter' | translate }}  {{ 't-m-properties.t-gross-area' | translate }}"
                  [ngClass]="{ 'is-warning': submitted && form['grossArea'].errors && form['grossArea'].errors['warning'] }"
                  formControlName="grossArea">

              </div>
            </div>
            <!--end col-->

            <div class="col-lg-4">
              <div class="mb-3">
                <label for="grossDependentAreaInput" class="form-label">
                  {{ 't-m-properties.t-gross-dependent-area' | translate }} (m2)
                </label>

                <input type="number" class="form-control" id="grossDependentAreaInput"
                  placeholder="{{ 't-enter' | translate }}  {{ 't-m-properties.t-gross-dependent-area' | translate }}"
                  [ngClass]="{ 'is-warning': submitted && form['grossDependentArea'].errors && form['grossDependentArea'].errors['warning'] }"
                  formControlName="grossDependentArea">
              </div>
            </div>

            <div class="col-lg-4">
              <div class="mb-3">
                <label for="grossPrivateAreaInput" class="form-label">
                  {{ 't-m-properties.t-gross-private-area' | translate }} (m2)
                </label>

                <input type="number" class="form-control" id="grossPrivateAreaInput"
                  placeholder="{{ 't-enter' | translate }}  {{ 't-m-properties.t-gross-private-area' | translate }}"
                  [ngClass]="{ 'is-warning': submitted && form['grossPrivateArea'].errors && form['grossPrivateArea'].errors['warning'] }"
                  formControlName="grossPrivateArea">
              </div>
            </div>

            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="landareaInput" class="form-label">
                  {{ 't-m-properties.t-land-area' | translate }} (m2)
                </label>
                <input type="number" class="form-control" id="landareaInput"
                  placeholder="{{ 't-enter' | translate }}  {{ 't-m-properties.t-land-area' | translate }}"
                  [ngClass]="{ 'is-warning': submitted && form['landArea'].errors && form['landArea'].errors['warning'] }"
                  formControlName="landArea">
              </div>
            </div>

            <!--end col-->
            <div class="col-lg-4" *ngIf="isBuildingImplantationArea">
              <div class="mb-3">
                <label for="buildingImplantationAreaInput" class="form-label">
                  {{ 't-m-properties.t-building-implantation-area' | translate }} (m2)
                </label>
                <input type="number" class="form-control" id="buildingImplantationAreaInput"
                  placeholder="{{ 't-enter' | translate }}  {{ 't-m-properties.t-building-implantation-area' | translate }}"
                  formControlName="buildingImplantationArea">
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
    </div>
    <!--end row-->

    <div class="row" *ngIf=" dataToFormInit?.divisions.length > 0">
      <div class="card">
        <div class="card-header border-0 align-items-center d-flex pt-0 pb-2 border-bottom">
          <h4 class="card-title mb-0 flex-grow-1">
            {{ 't-m-properties.t-divisions' | translate }}
          </h4>

          <div class="dropdown">
            <button class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
              type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
              <i class=" ri-settings-2-line fs-14"></i>
            </button>

            <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
              style="min-width: 16rem;">
              <div class="d-flex flex-column gap-2 filter-check">
                <div class="form-check form-switch" *ngFor="let d of dataToFormInit.divisions">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-devision{{d.division.id}}"
                    formControlName="hideDivision{{d.division.id}}">

                  <label class="form-check-label" for="hide-devision{{d.division.id}}">
                    {{ 't-m-properties.t-hide' | translate }}
                    {{d.description}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="d-flex flex-wrap px-4">
              <ng-container *ngFor="let d of dataToFormInit.divisions; index as i">
                <div class="col-12 col-md-6 col-xl-4 mb-4">
                  <div class="row">
                    <div class="col-md-12 col-xl-12">
                      <h5 class="fs-13 fw-medium">{{d.description}}</h5>
                    </div>

                    <div class="col-xl-6 col-md-12">
                      <div class="row">
                        <div class="col col-md-6 col-xl-auto px-0">
                          <div class="input-step" [ngClass]="{
                            'is-warning': submitted && propertyAreasNearbyForm.hasError('warning')
                            && (propertyAreasNearbyForm.get('division' + d.division.id)?.value ?? 0) <= 0}">
                            <button type="button" class="minus" (click)="decrement(d.division)">–</button>

                            <input type="number" class="product-quantity" min="0" max="20" readonly
                              [formControlName]="'division' + d.division.id">

                            <button type="button" class="plus" (click)="increment(d.division)">+</button>
                          </div>
                        </div>

                        <div class="col col-md-6 col-xl-6"
                          [ngClass]="{'d-none': propertyAreasNearbyForm.get('division' + d.division.id)?.value === 0}">
                          <!-- <div class="dropdown" ngbDropdown>
                                                        <button type="button" class="btn btn-icon rounded-circle"
                                                            ngbDropdownToggle>
                                                            <i class="fs-22 ms-1 ri-list-settings-line text-muted"></i>
                                                        </button>
                                                        <div class="dropdown-menu dropdown-menu-lg p-0" ngbDropdownMenu>

                                                            <div
                                                                class="dropdown-head bg-primary bg-soft-primary rounded-top">
                                                                <div class="p-3">
                                                                    <div class="row align-items-center">
                                                                        <div class="col">
                                                                            <h6 class="m-0 fs-16 fw-semibold">
                                                                                {{d.description}}
                                                                            </h6>
                                                                        </div>
                                                                        <div class="col-auto dropdown-tabs">
                                                                            <span
                                                                                class="badge fs-13 text-black">{{propertyAreasNearbyForm.get('division'+d.division.id)?.value}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <ngx-simplebar class="px-3 mx-n3 mb-2"
                                                                    [ngStyle]="{ 'height.vh': 30 }"
                                                                    [options]="{ forceVisible: true }">
                                                                    <div class="vstack gap-3">
                                                                        <ng-container
                                                                            *ngFor="let num of selectValueNumber; let i = index">
                                                                            <div class="d-flex align-items-center"
                                                                                *ngIf="num <=propertyAreasNearbyForm.get('division'+d.division.id)?.value 
                                                                                                            && propertyAreasNearbyForm.get('areaInput-'+d.division.id+'-'+(i+1))">
                                                                                <div class="flex-shrink-0 me-3">
                                                                                    <h5>
                                                                                        {{i+1}}</h5>
                                                                                </div>
                                                                                <div class="flex-grow-1">

                                                                                    <input type="number"
                                                                                        class="form-control form-control-sm"
                                                                                        id="areaInput{{i+1}}"
                                                                                        placeholder="Enter land area"
                                                                                        formControlName="areaInput-{{d.division.id}}-{{i+1}}">
                                                                                </div>
                                                                                <div class="flex-shrink-0">
                                                                                    <div
                                                                                        class="d-flex align-items-center gap-1">

                                                                                        <h5 class="fs-13 mb-0 ms-2">
                                                                                            <span
                                                                                                class="text-body d-block">m2</span>
                                                                                        </h5>
                                                                                        <div class="dropdown">
                                                                                            <button
                                                                                                class="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                                                                type="button">
                                                                                                <i
                                                                                                    class="ri-more-fill"></i>
                                                                                            </button>
                                                                                            <ul class="dropdown-menu">
                                                                                                <li><a class="dropdown-item"
                                                                                                        (click)="deleteAreaDivision(d.division,'areaInput-'+d.division.id+'-'+(i+1))"><i
                                                                                                            class="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Delete</a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </ng-container>
                                                                    </div>
                                                                </ngx-simplebar>
                                                            </div>
                                                        </div>
                                                    </div> -->
                          <div class="dropdown">
                            <button
                              class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
                              type="button" data-bs-toggle="dropdown" aria-expanded="false"
                              data-bs-auto-close="outside">
                              <i class="fs-18 ri-list-settings-line"></i>
                            </button>

                            <div class="border border-primary dropdown-menu dropdown-menu-end  border-input-custom pt-0"
                              style="min-width: 16rem;">
                              <div class="dropdown-head bg-light rounded-top">
                                <div class="p-3">
                                  <div class="row align-items-center">
                                    <div class="col">
                                      <h6 class="m-0 fs-16 fw-semibold">
                                        {{d.description}}
                                      </h6>
                                    </div>

                                    <div class="col-auto dropdown-tabs">
                                      <span class="badge fs-13 text-black">
                                        {{propertyAreasNearbyForm.get('division'+d.division.id)?.value}}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="card-body">
                                <ngx-simplebar class="px-3 mx-n3 mb-2" [ngStyle]="{ 'height.vh': 30 }"
                                  [options]="{ forceVisible: true }">
                                  <div class="vstack gap-3">
                                    <ng-container *ngFor="let num of selectValueNumber; let i = index">
                                      <div class="d-flex align-items-center"
                                        *ngIf="num <=propertyAreasNearbyForm.get('division'+d.division.id)?.value 
                                                                                                                                                                        && propertyAreasNearbyForm.get('areaInput-'+d.division.id+'-'+(i+1))">
                                        <div class="flex-shrink-0 me-3">
                                          <h5>
                                            {{i+1}}</h5>
                                        </div>
                                        <div class="flex-grow-1">

                                          <input type="number" class="form-control form-control-sm"
                                            id="areaInput{{i+1}}" placeholder="{{'t-enter-area' | translate}}"
                                            formControlName="areaInput-{{d.division.id}}-{{i+1}}">
                                        </div>
                                        <div class="flex-shrink-0">
                                          <div class="d-flex align-items-center gap-1">

                                            <h5 class="fs-13 mb-0 ms-2">
                                              <span class="text-body d-block">m2</span>
                                            </h5>
                                            <div class="dropdown">
                                              <button class="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                type="button">
                                                <i class="ri-more-fill"></i>
                                              </button>
                                              <ul class="dropdown-menu">
                                                <li><a class="dropdown-item"
                                                    (click)="deleteAreaDivision(d.division,'areaInput-'+d.division.id+'-'+(i+1))"><i
                                                      class="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Delete</a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-container>
                                  </div>
                                </ngx-simplebar>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- </div> -->
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!--end row-->

    <div class="row" *ngIf="dataToFormInit?.nearby.length > 0">
      <div class="card">
        <div class="card-header border-0 align-items-center d-flex pt-0 pb-2 border-bottom">
          <h4 class="card-title mb-0 flex-grow-1">
            {{ 't-m-properties.t-nearby' | translate }}
          </h4>
          <div class="dropdown"><button
              class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
              type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"><i
                class=" ri-settings-2-line fs-14"></i></button>
            <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
              style="min-width: 16rem;">
              <div class="d-flex flex-column gap-2 filter-check">
                <div class="form-check form-switch" *ngFor="let n of dataToFormInit.nearby">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-nearby{{n.nearby.id}}"
                    formControlName="hideNearby{{n.nearby.id}}">
                  <label class="form-check-label" for="hide-nearby{{n.nearby.id}}">
                    {{ 't-m-properties.t-hide' | translate }}
                    {{n.description}}
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-xl-4 mb-4 mt-2 pe-0 pe-md-5" *ngFor="let n of dataToFormInit.nearby">
              <div class="row">
                <div class="d-flex flex-wrap align-items-start">
                  <div class="col-12">
                    <div class="mb-3">
                      <div class="form-check form-switch form-switch-primary form-switch-md">
                        <input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck{{n.nearby.id}}"
                          checked formControlName="nearby{{n.nearby.id}}">
                        <label class="form-check-label" for="SwitchCheck{{n.nearby.id}}">{{n.description}}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 pe-0 pe-md-5"
                    [ngClass]="{'d-none':!propertyAreasNearbyForm.get('nearby'+n.nearby.id)?.value}">
                    <div class="row">
                      <div class="col-lg-6 col-12">
                        <div class="mb-3 ">
                          <input type="number" class="form-control" placeholder="0"
                            formControlName="valNearby-{{n.nearby.id}}">
                        </div>
                      </div>

                      <div class="col-lg-6 col-12" *ngIf="dataToFormInit?.units?.length>0">
                        <ng-select appendTo=".modal-create-properties" [items]="dataToFormInit.units" [multiple]="false" bindLabel="description"
                          bindValue="id" formControlName="unitNearBy-{{n.nearby.id}}" [clearable]="false"
                          class="details-propertytype">
                        </ng-select>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <!-- <div class="vstack gap-3">
                            <div class="d-flex align-items-center">
                                <div class="flex-shrink-0 me-3">
                                    <div>
                                        <div class="form-check form-switch form-switch-primary form-switch-md">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                id="SwitchCheck{{n.nearby.id}}" checked
                                                formControlName="nearby{{n.nearby.id}}">
                                            <label class="form-check-label"
                                                for="SwitchCheck{{n.nearby.id}}">{{n.description}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-1">
                                    <div class="pe-2">
                                        <input type="text" class="form-control" placeholder="val">
                                    </div>


                                </div>
                                <div class="flex-grow-1" *ngIf="dataToFormInit?.units?.length>0">
                                    <div class="align-items-center">


                                        <ng-select appendTo=".modal-create-properties" [items]="dataToFormInit.units" [multiple]="false"
                                            bindLabel="description" bindValue="id" formControlName="unit"
                                            [clearable]="false" class="details-propertytype">
                                        </ng-select>

                                    </div>
                                </div>
                            </div>
                        </div> -->
            </div>


          </div>
          <!--end row-->
        </div>
      </div>
    </div>
    <!--end row-->
  </form>
</ngx-simplebar>